const SelectboxSkeleton = () => (
    <div className="skeleton-box rounded-md w-32 h-10 mr-1">
        <span />
    </div>
)

export default SelectboxSkeleton;